export function LocationOnIcon({
  color = '#101010',
  className,
}: {
  color?: string
  className?: string
}) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
      focusable={false}
    >
      <path
        d="M7.00004 7.00001C7.32087 7.00001 7.59553 6.88577 7.824 6.6573C8.05247 6.42882 8.16671 6.15417 8.16671 5.83334C8.16671 5.51251 8.05247 5.23785 7.824 5.00938C7.59553 4.78091 7.32087 4.66667 7.00004 4.66667C6.67921 4.66667 6.40455 4.78091 6.17608 5.00938C5.94761 5.23785 5.83337 5.51251 5.83337 5.83334C5.83337 6.15417 5.94761 6.42882 6.17608 6.6573C6.40455 6.88577 6.67921 7.00001 7.00004 7.00001ZM7.00004 12.8333C5.43476 11.5014 4.26567 10.2642 3.49275 9.12188C2.71983 7.97952 2.33337 6.92223 2.33337 5.95001C2.33337 4.49167 2.80247 3.32987 3.74067 2.46459C4.67886 1.59931 5.76532 1.16667 7.00004 1.16667C8.23476 1.16667 9.32122 1.59931 10.2594 2.46459C11.1976 3.32987 11.6667 4.49167 11.6667 5.95001C11.6667 6.92223 11.2802 7.97952 10.5073 9.12188C9.73442 10.2642 8.56532 11.5014 7.00004 12.8333Z"
        fill={color}
      />
    </svg>
  )
}
